/**
 * IntentionalError:
 * For testing logging/monitoring & previewing ErrorBoundary design.
 */const IntentionalError=()=>{throw'This error is intentional.';};export default IntentionalError;